import _ from 'lodash'

export function create_map(element, center, zoom, styles, show_controls) {
    var default_center = {
            lat: 54.0901497,
            lng: 12.1161439
        },
        default_controls = true,
        default_zoom = 9,
        default_styles = [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [{
                        "hue": "#ff0000"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "weight": "1"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [{
                        "weight": "3.39"
                    },
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#000000"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [{
                        "color": "#ff805d"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [{
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    },
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "weight": "0.47"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "all",
                "stylers": [{
                    "visibility": "on"
                }]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [{
                        "color": "#ffffff"
                    },
                    {
                        "visibility": "on"
                    },
                    {
                        "gamma": "1"
                    },
                    {
                        "weight": "0.38"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [{
                        "visibility": "off"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [{
                        "visibility": "simplified"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "transit.station.bus",
                "elementType": "all",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [{
                        "color": "#4b4f4f"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];

    var map = new google.maps.Map(element, {
        center: (center == null) ? default_center : center,
        zoom: (zoom == null) ? default_zoom : zoom,
        styles: (styles == null) ? default_styles : styles,
        disableDefaultUI: (show_controls == null) ? default_controls : show_controls,
    });

    return map;
}

export function create_marker(map, position) {
    var marker = new google.maps.Marker({
        position: position,
        map: map,
        // icon: require('@/assets/images/mapMarkerSmall.svg'),
        icon: require('@/assets/images/mapMarker.png'),
    });
    return marker;
}


export function update_markers(map, markers, items, marker_created_callback) {
    /**
     * delete markers that are not in the result set
     * but keep existing markers that are still in the result set to
     * be more efficient
     *
     * avoid O(n^2) complexity - can happen easily here
     **/
    var remove_items = {};
    _.forOwn(markers, (val, key) => {
        remove_items[key] = true;
    });

    _.each(items, (item) => {
        if (!item) {
            return;
        }
        var id = item.objectId;
        if (id && item.position) {
            if (!markers.hasOwnProperty(id)) {
                markers[id] = create_marker(map, {
                    lat: item.position.latitude,
                    lng: item.position.longitude,
                });
                // callback for marker creation
                if (
                    marker_created_callback && 
                    typeof(marker_created_callback) === 'function'
                ) {
                    marker_created_callback(markers[id], id);
                }
            } else {
                // marker already exists
                // don't remove this marker
                remove_items[id] = false;
            }
        }
    });

    // remove markers that are not in results
    _.forOwn(remove_items, (val, key) => {
        if (val === true) {
            // https://developers.google.com/maps/documentation/javascript/examples/marker-remove
            var marker = markers[key];
            marker.setMap(null);
            delete markers[key];
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/map.js